import { BusinessDocumentType, BusinessKYBDocumentType, BusinessKYBStatus, BusinessKYCDocumentType, BusinessKYCStatus, } from '../domain/enums/index.js';
// Whether the organisation's KYB is done and passed. `flags.isVerified` is an
// admin override that also force-writes the KYB status, so either side is
// enough — both server and portal have long treated them as equivalent.
export const isBusinessKYBVerified = (business) => Boolean(business?.meta?.kyb?.status === BusinessKYBStatus.Success ||
    business?.meta?.flags?.isVerified);
// The business-user counterpart: whether this person's own KYC is done and
// passed.
export const isBusinessUserKYCVerified = (user) => Boolean(user?.meta?.kyc?.status === BusinessKYCStatus.Success ||
    user?.meta?.flags?.isVerified);
// Submitted for review or already passed: either way the details verification
// read are no longer the owner's to change.
export const isBusinessKYBSubmittedOrVerified = (business) => isBusinessKYBVerified(business) ||
    Boolean(business?.meta?.kyb?.status &&
        business.meta.kyb.status !== BusinessKYBStatus.NotStarted);
export const isBusinessUserKYCSubmittedOrVerified = (user) => isBusinessUserKYCVerified(user) ||
    Boolean(user?.meta?.kyc?.status &&
        user.meta.kyc.status !== BusinessKYCStatus.NotStarted);
export const mapBusinessKYBToDocumentType = {
    [BusinessKYBDocumentType.BusinessType]: BusinessDocumentType.Text,
    [BusinessKYBDocumentType.BusinessNature]: BusinessDocumentType.Text,
    [BusinessKYBDocumentType.BusinessNumber]: BusinessDocumentType.Text,
    [BusinessKYBDocumentType.BusinessWebsite]: BusinessDocumentType.Text,
    [BusinessKYBDocumentType.BusinessAddress]: BusinessDocumentType.Text,
    [BusinessKYBDocumentType.ProofOfBusinessAddress]: BusinessDocumentType.File,
    [BusinessKYBDocumentType.BusinessCertificate]: BusinessDocumentType.File,
    [BusinessKYBDocumentType.ArticlesDocument]: BusinessDocumentType.File,
    [BusinessKYBDocumentType.ShareholderRegistry]: BusinessDocumentType.File,
    [BusinessKYBDocumentType.BusinessVolume]: BusinessDocumentType.Text,
};
export const mapBusinessUserKYCToDocumentType = {
    [BusinessKYCDocumentType.RepresentativeType]: BusinessDocumentType.Text,
    [BusinessKYCDocumentType.DateOfBirth]: BusinessDocumentType.Text,
    [BusinessKYCDocumentType.Address]: BusinessDocumentType.Text,
    [BusinessKYCDocumentType.BankStatement]: BusinessDocumentType.File,
    [BusinessKYCDocumentType.BusinessCertificate]: BusinessDocumentType.File,
    [BusinessKYCDocumentType.Country]: BusinessDocumentType.Text,
    [BusinessKYCDocumentType.IDFront]: BusinessDocumentType.Photo,
    [BusinessKYCDocumentType.IDBack]: BusinessDocumentType.Photo,
    [BusinessKYCDocumentType.Phone]: BusinessDocumentType.Text,
    [BusinessKYCDocumentType.Selfie]: BusinessDocumentType.Photo,
    [BusinessKYCDocumentType.ProofOfAddress]: BusinessDocumentType.File,
    [BusinessKYCDocumentType.ProofOfIncome]: BusinessDocumentType.File,
    [BusinessKYCDocumentType.BVN]: BusinessDocumentType.Text,
    [BusinessKYCDocumentType.DriverLicense]: BusinessDocumentType.Text,
    [BusinessKYCDocumentType.Passport]: BusinessDocumentType.Text,
    [BusinessKYCDocumentType.NationalID]: BusinessDocumentType.Text,
    [BusinessKYCDocumentType.PaymentMethod]: BusinessDocumentType.Photo,
    [BusinessKYCDocumentType.ResidencePermit]: BusinessDocumentType.File,
    [BusinessKYCDocumentType.VehicleRegistration]: BusinessDocumentType.File,
    [BusinessKYCDocumentType.VoterId]: BusinessDocumentType.Text,
    [BusinessKYCDocumentType.Others]: BusinessDocumentType.File,
};
// The documents compliance may ask for in an EDD request (admin "Request
// Additional Documents"): the file and photo types above, so a text field
// (website, date of birth, BVN, ...) is never asked for as a document.
// PAYMENT_METHOD (a card photo) and OTHERS (the upload form's catch-all) are
// left out. The admin checklist and the server's request validation both read
// these.
export const requestableBusinessKYBDocuments = Object.entries(mapBusinessKYBToDocumentType)
    .filter(([, docType]) => docType === BusinessDocumentType.File)
    .map(([doc]) => doc);
const nonRequestableBusinessUserKYCDocuments = new Set([BusinessKYCDocumentType.PaymentMethod, BusinessKYCDocumentType.Others]);
export const requestableBusinessUserKYCDocuments = Object.entries(mapBusinessUserKYCToDocumentType)
    .filter(([doc, docType]) => (docType === BusinessDocumentType.File ||
    docType === BusinessDocumentType.Photo) &&
    !nonRequestableBusinessUserKYCDocuments.has(doc))
    .map(([doc]) => doc);
//# sourceMappingURL=businessKYCUtils.js.map